import { Button, Grid, Stack, Typography } from '@mui/material'
import React from 'react'
import MainCard from 'ui-component/cards/MainCard'
import Box from '@mui/material/Box';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';
import AgentTable from './TableComponent';
import { FaFilterCircleXmark } from "react-icons/fa6";
import { useState } from 'react';
import { useEffect } from 'react';


const CspTable = (props) => {
    const [FilterStatus, setFilterStatus] = useState({
        status: "select"
    })

    const [Data, setData] = useState(null)

    const handleFilterChange = (event) => {
        setFilterStatus({ ...FilterStatus, "status": event.target.value })
        props.handleStatusChange(event.target.value)
    }
    const handleClearFilter = () => {
        setFilterStatus({ status: "select" })
        props.handleStatusChange("")

    }

    // console.log("props",props);


    useEffect(() => {
        if (!props.data?.data) return;

        const rawData = props.data?.data;

        if (FilterStatus.status === "" || FilterStatus.status === "select") {
            setData(rawData);
        } else {
            const filteredData = rawData.data.filter(
                item => item
            );

            const newData = {
                ...rawData,             // keep page, totalPages, etc.
                data: filteredData      // replace only the data field
            };

            setData(newData);
        }
    }, [props.data, FilterStatus]);






    return (
        <MainCard sx={{ mt: 1 }} >
            <Grid container justifyContent="space-between">
                <Grid item md={12}>
                    <Grid container spacing={2} alignItems="center" justifyContent="space-between">
                        <Grid item md={5} xs={12} >
                            <Box sx={{ minWidth: 120 }}>
                                <Typography variant='h5' sx={{ color: "#20415C", marginBottom: 1 }} fontWeight={600} >CSP Status</Typography>
                            </Box>
                        </Grid>
                        <Grid item md={3} xs={12}>
                            <Stack direction="row" gap={1} alignItems="center">
                                <Box sx={{ minWidth: 120 }}>
                                    <FormControl fullWidth size='small' variant='standard'>
                                        <InputLabel id="demo-simple-select-label">Status</InputLabel>
                                        <Select
                                            labelId="demo-simple-select-label"
                                            id="demo-simple-select"
                                            value={FilterStatus.status ? FilterStatus.status : ""}
                                            label="Status"
                                            onChange={handleFilterChange}
                                        >
                                            <MenuItem value={"select"}>All</MenuItem>
                                            {/* <MenuItem value={'Approval Pending from Wealth Mgr'}>Approval Pending from Wealth Mgr</MenuItem> */}
                                            {/* <MenuItem value={'Rejected from Wealth Mgr '}>Rejected from Wealth Mgr </MenuItem> */}
                                            {/* <MenuItem value={'Approved By TM/WH/SH '}>Approved By TM/WH/SH </MenuItem> */}
                                            {/* <MenuItem value={'Application/KYC-Rejected By Ops'}>Application/KYC-Rejected By Ops</MenuItem> */}
                                            <MenuItem value={"6"}>Pending for Activation</MenuItem>

                                            <MenuItem value={"7"}>Approved/Activated</MenuItem>
                                            <MenuItem value={"99"}>Deleted</MenuItem>
                                            {/* <MenuItem value={'Approved and Activated by BDOPS'}>Approved and Activated by BDOPS</MenuItem> */}
                                            {/* <MenuItem value={'Rejected by BDOPS'}>Rejected by BDOPS</MenuItem> */}
                                            <MenuItem value={"10"}>Awaited/Pending for Code creation</MenuItem>
                                            {/* <MenuItem value={'Pending/Incomplete KYC- Received'}>Pending/Incomplete KYC- Received</MenuItem> */}



                                        </Select>
                                    </FormControl>
                                </Box>

                                <Button
                                    variant='contained'
                                    color="secondary"
                                    onClick={handleClearFilter}
                                >
                                    <FaFilterCircleXmark />
                                </Button>
                            </Stack>
                        </Grid>

                    </Grid>
                </Grid>
            </Grid>
            <Grid container>
                <Grid item xs={12}>
                    <AgentTable data={Data ? { "data": Data } : null} filter={props.filter} FilterStatus={FilterStatus} handlePageChange={props.handlePageChange} GetList={props.GetList} page={props.page} />
                </Grid>
            </Grid>
        </MainCard>
    )
}

export default CspTable